import * as z from 'zod'; 

import { Media, CTA } from './strapiSchema';


const blockBlocBoutonDAction = z.object({
  __component: z.literal('blocks.bloc-bouton-d-action'),
  id: z.number(),
  button: CTA,
});

export type BlocBoutonDActionType = z.infer<typeof blockBlocBoutonDAction>;

const blockBlocEquipe = z.object({
  __component: z.literal('blocks.bloc-equipe'),
  id: z.number(),
  preTitle: z.string(),
  title: z.string().nullish(),
  experts: z.array(z.object({
    id: z.number(),
    documentId: z.string(),
    name: z.string(),
    role: z.string(),
    image: Media,
  })).nullish(),
  button: CTA.nullish(),
});

export type BlocEquipeType = z.infer<typeof blockBlocEquipe>;

const blockBlocFAQ = z.object({
  __component: z.literal('blocks.bloc-faq'),
  id: z.number(),
  items: z.array(z.object({
    order: z.number(),
    label: z.string(),
    preTitle: z.string(),
    title: z.string(),
    description: z.string().nullish(),
    checklist: z.array(z.object({
      title: z.string(),
      description: z.string().nullish(),
    })),
    primaryButton: CTA.nullish(),
    secondaryButton: CTA.nullish(),
  })),
});

export type BlocFAQType = z.infer<typeof blockBlocFAQ>;

const blockBlocHero = z.object({
  __component: z.literal('blocks.bloc-hero'),
  id: z.number(),
  bgImage: Media.nullish(),
  title: z.string(),
  description: z.string().nullish(),
  isButtonVisible: z.boolean().nullish(),
});

export type BlocHeroType = z.infer<typeof blockBlocHero>;

const blockBlocListe = z.object({
  __component: z.literal('blocks.bloc-liste'),
  id: z.number(),
  preTitle: z.string(),
  title: z.string(),
  items: z.array(CTA),
});

export type BlocListeType = z.infer<typeof blockBlocListe>;

const blockBlocListeMedia = z.object({
  __component: z.literal('blocks.bloc-liste-and-media'),
  id: z.number(),
  preTitle: z.string().nullish(),
  title: z.string(),
  description: z.string().nullish(),
  image: Media,
  imagePosition: z.enum(['Gauche', 'Droite']),
  sections: z.array(z.object({
    title: z.string().nullish(),
    description: z.string().nullish(),
    icon: Media.nullish(),
  })).nullish(),
  button: CTA.nullish(),
});

export type BlocListeMediaType = z.infer<typeof blockBlocListeMedia>;

const blockBlocMarques = z.object({
  __component: z.literal('blocks.bloc-marques'),
  id: z.number(),
  title: z.string(),
  carouselSpeed: z.enum(['lente', 'moyenne', 'rapide']),
  brands: z.array(z.object({
    brand: z.string(),
    url: z.string(),
    image: Media.nullish(),
  })).nullish(),
});

export type BlocMarquesType = z.infer<typeof blockBlocMarques>;

const blockBlocMiseEnAvant = z.object({
  __component: z.literal('blocks.bloc-mise-en-avant'),
  id: z.number(),
  preTitle: z.string(),
  title: z.string(),
});

export type BlocMiseEnAvantType = z.infer<typeof blockBlocMiseEnAvant>;

const blockBlocMiseEnAvantCommande = z.object({
  __component: z.literal('blocks.bloc-mise-en-avant-commande'),
  id: z.number(),
  preTitle: z.string(),
  title: z.string(),
  cards: z.array(z.object({
    order: z.number(),
    title: z.string(),
    description: z.string(),
  })),
});

export type BlocMiseEnAvantCommandeType = z.infer<typeof blockBlocMiseEnAvantCommande>;

const blockBlocReassurance = z.object({
  __component: z.literal('blocks.bloc-reassurance'),
  id: z.number(),
  title: z.string(),
  subTitle: z.string(),
  items: z.array(z.object({
    title: z.string(),
    subTitle: z.string(),
    icon: Media,
  })),
  button: CTA,
  reinsuranceLine: z.array(z.object({
    text: z.string(),
  })),
});

export type BlocReassuranceType = z.infer<typeof blockBlocReassurance>;

const blockBlocTexte = z.object({
  __component: z.literal('blocks.bloc-texte'),
  id: z.number(),
  text: z.string().nullish(),
  bgColor: z.enum(['gris', 'blanc']).nullish(),
});

export type BlocTexteType = z.infer<typeof blockBlocTexte>;

const blockBlocTexteMedia = z.object({
  __component: z.literal('blocks.bloc-texte-and-media'),
  id: z.number(),
  title: z.string().nullish(),
  description: z.string().nullish(),
  image: Media,
  imagePosition: z.enum(['Gauche', 'Droite']),
  
});

export type BlocTexteMediaType = z.infer<typeof blockBlocTexteMedia>;

const blockBlocListeCards = z.object({
  __component: z.literal('blocks.bloc-liste-cards'),
  id: z.number(),
  title: z.string(),
  subTitle: z.string(),
  cards: z.array(z.object({
    id: z.number(),
    image: Media,
    title: z.string(),
    description: z.string(),
    cta: CTA,
  })),  
});

export type BlocListeCardsType = z.infer<typeof blockBlocListeCards>;

// blockSection* only available for Home Page 
const blockSectionEnTete = z.object({
  __component: z.literal('home.section-en-tete'),
  id: z.number(),
  title: z.string(),
  cover: z.array(Media),
  checklist: z.array(z.object({
    text: z.string(),
    icon: Media,
  })),
  button: CTA,
  keyFigures: z.array(z.object({
    title: z.string(),
    description: z.string(),
  })),
});

export type SectionEnTeteType = z.infer<typeof blockSectionEnTete>;

const blockSectionAvis = z.object({
  __component: z.literal('home.section-avis'),
  id: z.number(),
  title: z.string(),
});

export type SectionAvisType = z.infer<typeof blockSectionAvis>;

const blockSectionActualite = z.object({
  __component: z.literal('home.section-actualite'),
  id: z.number(),
  button: CTA,
});

export type SectionActualiteType = z.infer<typeof blockSectionActualite>;

const blockSectionAvantages = z.object({
  __component: z.literal('home.section-avantages'),
  id: z.number(),
  preTitle: z.string(),
  title: z.string(),
  image: Media,
  sections: z.array(z.object({
    title: z.string(),
    description: z.string(),
    icon: Media,
  })).min(1),
});

export type SectionAvantagesType = z.infer<typeof blockSectionAvantages>;

// Sections 

const sectionsSectionPourQui = z.object({
  __component: z.literal('sections.section-pour-qui'),
  id: z.number(),
  preTitle: z.string(),
  title: z.string(),
  image: Media,
  blockTitle: z.string(),
  blockDescription: z.string(),
  items: z.array(z.object({
    icon: Media,
    text: z.string(),
  })),
  blockEndText: z.string(),
});

export type SectionPourQuiType = z.infer<typeof sectionsSectionPourQui>;

const sectionsSectionAvantages2 = z.object({
  __component: z.literal('sections.section-avantages-pneumaclic-2'),
  id: z.number(),
  preTitle: z.string(),
  title: z.string(),
  cards: z.array(z.object({
    icon: Media,
    title: z.string(),
    description: z.string(),
    text: z.string(),
  })),
});

export type SectionAvantages2Type = z.infer<typeof sectionsSectionAvantages2>;

const sectionsSectionRecyclage = z.object({
  __component: z.literal('sections.section-recyclage'),
  id: z.number(),
  preTitle: z.string(),
  title: z.string(),
  description: z.string(),
  logo: Media,
  image: Media,
});

export type SectionRecyclageType = z.infer<typeof sectionsSectionRecyclage>;

export const blocksSchema = z.discriminatedUnion('__component', [
  blockBlocBoutonDAction,
  blockBlocEquipe,
  blockBlocFAQ,
  blockBlocHero,
  blockBlocListe,
  blockBlocListeMedia,
  blockBlocMarques,
  blockBlocMiseEnAvant,
  blockBlocMiseEnAvantCommande,
  blockBlocReassurance,
  blockBlocTexte,
  blockBlocTexteMedia,
  blockSectionEnTete,
  blockSectionAvis,
  blockSectionActualite,
  blockSectionAvantages,
  blockBlocListeCards,
  sectionsSectionPourQui,
  sectionsSectionAvantages2,
  sectionsSectionRecyclage,
]);

export type BlockType = z.infer<typeof blocksSchema>;
